import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { AddProgramDialog, RemoveProgramDialog, ParticipantList } from './index'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import { Scrollbars } from 'react-custom-scrollbars';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import deepOrange from '@material-ui/core/colors/deepOrange';
import request from 'superagent'
import moment from 'moment';
import * as Constants from '../constants'

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    position: "absolute",
    width: 125,
    right: 60,
    color: theme.palette.text.secondary,
  },
  terciaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    position: "absolute",
    right: 155,
    width: 50,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

function createData(id, first_name, last_name, city, age, tel, email, note, photo_permission, accepted) {
  return { id, first_name, last_name, city, age, tel, email, note, photo_permission, accepted };
}

class AdministrationLeader extends React.Component {
  state = {
    expanded: 0,
    snackbar_error_open: false,
    snackbar_message: "",
    loading: false,
    anchorEl: null,
    dialog_first_program_info_open: false,
    dialog_add_program_open: false,
    dialog_remove_program_open: false,
    all_program_data: [],
    program_data: [],
    selected_program: null,
    selected_program_data: [],
    children_data: [],
    addProgramEditMode: false,

    polite_form: "",
    first_name: null,
    last_name: null,
    email: null,
    tel: null,
    department: null,
  }

  constructor(props) {
    super(props)

    //Alle Programme laden
    this.loadAllPrograms();
  }

  loadAllPrograms = () => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getallprograms" })
      .end(function (err, res) {
        var result = res.text.trim();
        var obj = JSON.parse(result);
        currentComponent.setState({ all_program_data: obj, program_data: obj });
      });
  }

  saveAccountData = () => {
    this.setState({ error_first_name: false, error_last_name: false, error_email: false, error_tel: false, error_department: false, loading: true });

    var email = this.state.email === null ? this.props.userData.email : this.state.email;
    var tel = this.state.tel === null ? this.props.userData.tel : this.state.tel;
    var department = this.state.department === null ? this.props.userData.department : this.state.department;

    if (email !== "" && tel !== "" && department !== "") {
      let currentComponent = this;
      request.post(Constants.BACKEND_URL)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send({ command: "changeleaderdata", leader_id: this.props.userData.id, email: email, tel: tel, department: department })
        .end(function (err, res) {
          var result = res.text.trim();
          if (result === "1") {
            currentComponent.loadAllPrograms();
            currentComponent.setState({ loading: false });
          } else {
            currentComponent.setState({ loading: false, snackbar_open: true });
          }
        });
    } else {
      this.setState({ error_email: email === "", error_tel: tel === "", error_department: department === "" });
    }
  }

  loadChildrenForProgram = program => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getparticipants", program_id: program.id })
      .end(function (err, res) {
        var result = res.text.trim();
        var obj = JSON.parse(result);
        var data_records = [];
        obj.map((item, key) => {
          data_records.push(createData(key, item.first_name, item.last_name, item.city, currentComponent.calculateAge(item.dob, program.date_from), item.tel, item.email, item.note === "" ? "-" : item.note, item.photo_permission === "1" ? "Ja" : "Nein", item.accepted));
        });
        currentComponent.setState({ selected_program: program, children_data: data_records });
      });
  }

  calculateAge = (dob, program_date) => {
    program_date = moment(program_date, "DD.MM.YYYY").toDate();
    var birthDate = moment(dob, "DD.MM.YYYY").toDate();
    var age_now = program_date.getFullYear() - birthDate.getFullYear();
    var m = program_date.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && program_date.getDate() < birthDate.getDate())) age_now--;
    return age_now;
  }

  addProgram = () => {
    this.setState({ dialog_add_program_open: true, selected_program: null, addProgramEditMode: false });
  }

  addedProgram = result => {
    this.setState({ dialog_add_program_open: false });
    if (result) this.loadAllPrograms();
  }

  removeProgram = program => {
    this.setState({ dialog_remove_program_open: true, selected_program: program });
  }

  removedProgram = result => {
    this.setState({ dialog_remove_program_open: false });
    if (result) this.loadAllPrograms();
  }

  editProgram = program => {
    this.setState({ dialog_add_program_open: true, selected_program: program, addProgramEditMode: true });
  }

  addThisYear = program => {
    this.setState({ dialog_add_program_open: true, selected_program: program });
  }

  handlePanelChange = program => (event, expanded) => {
    this.setState({ expanded: expanded ? program.id.toString() : false });
    if (program.leader_id === this.props.userData.id) {
      this.loadChildrenForProgram(program);
    } else {
      this.setState({ selected_program: null });
    }
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false, snackbar_success_open: false });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <Fragment>
        {/* Kopfzeile */}
        <div style={{ position: "absolute", width: "100%", height: 26, top: 64, background: deepOrange[400], boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.5)" }}>
          {this.props.server_settings.state === 6 && <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(20%)", left: 0 }} inline>{"Account-Daten"}</Typography>}
          {this.props.server_settings.state === 6 && <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(40%)", left: "calc(20%)" }} inline>{"Programme für dieses Jahr"}</Typography>}
          {this.props.server_settings.state === 6 && <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(40%)", left: "calc(60%)" }} inline>{"Programme vom letzten Jahr"}</Typography>}
          {this.props.server_settings.state !== 6 && <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(40%)", left: 0 }} inline>{"Alle Programme"}</Typography>}
        </div>
        {/* Leiter-Daten */}
        {this.props.server_settings.state === 6 && <div style={{ position: "absolute", width: "20%", height: "calc(100% - 130px)", top: 90, background: "white", opacity: 0.6 }}>
          <div style={{ position: "absolute", top: 0, bottom: 65, left: 0, right: 0 }}>
            <Scrollbars>
              <div style={{ padding: 15 }}>
                <Typography>Bitte tragen Sie hier Ihre Daten ein. Die Daten können nur bis zum Einsendeschluss der Programme geändert werden.</Typography>
                {/* Anrede */}
                <FormControl style={{ width: "30%", marginRight: "70%", marginTop: 10 }} disabled>
                  <InputLabel htmlFor="pf" shrink={this.props.userData.polite_form !== ""}>Anrede</InputLabel>
                  <Select value={parseInt(this.props.userData.polite_form)} inputProps={{ id: 'pf' }} style={{ height: 30 }}>
                    <MenuItem value={1} selected>Frau</MenuItem>
                    <MenuItem value={2}>Herr</MenuItem>
                  </Select>
                </FormControl>
                {/* Vorname */}
                <TextField label="Vorname" value={this.props.userData.first_name} onKeyPress={this.onEnterPressed} style={{ width: "49%", marginTop: 10, marginRight: "2%" }} disabled />
                {/* Nachname */}
                <TextField label="Nachname" value={this.props.userData.last_name} onKeyPress={this.onEnterPressed} style={{ width: "49%", marginTop: 10 }} disabled />
                {/* E-Mail */}
                <TextField label="E-Mail-Adresse" value={this.state.email === null ? this.props.userData.email : this.state.email} onKeyPress={this.onEnterPressed} onChange={this.handleChange('email')} style={{ width: "100%", marginTop: 10 }} type="email" error={this.state.error_email_register} required />
                {/* Tel */}
                <TextField label="Handynummer" value={this.state.tel === null ? this.props.userData.tel : this.state.tel} onKeyPress={this.onEnterPressed} onChange={this.handleChange('tel')} style={{ width: "100%", marginTop: 10 }} type="tel" error={this.state.error_tel_register} required />
                {/* Verein / Organisation / Institution */}
                <TextField label="Verein / Organisation / Institution" value={this.state.department === null ? this.props.userData.department : this.state.department} onChange={this.handleChange('department')} onKeyPress={this.onEnterPressed} style={{ width: "100%", marginTop: 10 }} error={this.state.error_department} required />
              </div>
            </Scrollbars>
          </div>
          {/* Leiste */}
          {this.props.server_settings.state === 6 && <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 65, background: "grey" }}>
            {this.props.server_settings.state === 6 && <Fab variant="extended" color="secondary" style={{ position: "absolute", bottom: 10, right: 10 }} disabled={this.state.loading} onClick={this.saveAccountData}>
              <SaveIcon style={{ marginRight: 10 }} />
              {"Daten speichern"}
              {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Fab>}
          </div>}
        </div>}
        {/* Programme von diesem Jahr */}
        <div style={{ position: "absolute", left: this.props.server_settings.state === 6 ? "20%" : 0, width: "40%", height: "calc(100% - 130px)", top: 90 }}>
          <div style={{ position: "absolute", top: 0, bottom: this.props.server_settings.state === 6 ? 65 : 0, left: 0, right: 0 }}>
            <Scrollbars>
              {this.state.program_data.map(program => (
                <Fragment>
                  {(program.event.toLowerCase().includes(this.props.searchString.toLowerCase()) || program.year_ai.toString().includes(this.props.searchString) || program.city.toLowerCase().includes(this.props.searchString.toLowerCase())) && program.date_from.includes(new Date().getFullYear().toString()) && <ExpansionPanel expanded={this.state.expanded === program.id.toString()} onChange={this.handlePanelChange(program)} style={{ borderRadius: 10, margin: 5, marginRight: 10 }}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading} align="left" style={{ marginRight: 160, color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{program.year_ai + ". " + program.event}</Typography>
                      <Typography className={classes.secondaryHeading} align="right" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'short' }) + ". " + program.date_from.substring(0, 6) + (program.time_from !== "" ? " " + program.time_from : "")}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{"Termin: " + moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'long' }) + " " + program.date_from + (program.date_to !== program.date_from ? " - " + program.date_to : "") + (program.time_from !== "" ? " von " + program.time_from + " bis " + program.time_to : "")}</Typography>
                        <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{"Treffpunkt: " + program.location}</Typography>
                        <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{"Leiter/in: " + program.first_name + " " + program.last_name + ", " + program.department}</Typography>
                        <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>Kontakt: <Link href={"mailto:" + program.email}>{program.email}</Link> / <Link href={"tel:" + program.tel}>{program.tel}</Link></Typography>
                        {program.cl_first_name !== "" && <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{"Co-Leiter/in: " + program.cl_first_name + " " + program.cl_last_name}</Typography>}
                        {program.cl_first_name !== "" && <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>Kontakt: <Link href={"mailto:" + program.cl_email}>{program.cl_email}</Link> / <Link href={"tel:" + program.cl_tel}>{program.cl_tel}</Link></Typography>}
                        <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{"Kosten: " + (program.price === "0" ? "kostenlos" : parseFloat(program.price).toFixed(2).replace(".", ",") + " €")}</Typography>
                        {(program.age_min !== "0" || program.age_max !== "0") && <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{"Alter: " + (program.age_max === "0" ? "ab " + program.age_min + " Jahren" : program.age_min + " - " + program.age_max + " Jahre")}</Typography>}
                        {program.push_notes !== "" && <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB") }}>{"Mitzubringen: " + program.push_notes}</Typography>}

                        <Typography align="left" style={{ color: (program.leader_id === this.props.userData.id ? "#444" : "#BBB"), marginTop: 10, whiteSpace: "pre-line" }}>{program.description.split(" ^ ").join("\n").split("^").join("\n")}</Typography>

                        {this.props.server_settings.state === 6 && program.leader_id === this.props.userData.id && <Fragment>
                          <Tooltip title={"Programm bearbeiten"} placement="top">
                            <Button variant="outlined" onClick={() => this.editProgram(program)} style={{ marginTop: 10, marginRight: 5 }} disabled={this.state.loading} color="primary">Programm bearbeiten</Button>
                          </Tooltip>
                          <Tooltip title={"Programm löschen"} placement="top">
                            <Button variant="outlined" onClick={() => this.removeProgram(program)} style={{ marginTop: 10 }} disabled={this.state.loading} color="primary">Programm löschen</Button>
                          </Tooltip>
                        </Fragment>}

                        {program.additional_info && <Tooltip title={"Zusätzliche Infos einsehen"} placement="top"><span><Button variant="outlined" href={"https://formulare-schemmerhofen.de/files/fepro/info_" + program.year_ai + ".pdf"} target="blank" style={{ marginTop: 10, marginRight: 10 }} disabled={this.state.loading} color="primary">
                          {"Zusätzliche Infos"}
                        </Button></span></Tooltip>}
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>}
                </Fragment>
              ))}
            </Scrollbars>
          </div>
          {/* Leiste */}
          {this.props.server_settings.state === 6 && <div style={{ position: "absolute", bottom: 0, width: "100%", height: 65, background: "grey", opacity: 0.6 }}>
            <Fab variant="extended" color="secondary" style={{ position: "absolute", bottom: 10, right: 10 }} disabled={this.state.loading} onClick={this.addProgram}><AddIcon style={{ marginRight: 10 }} />Neues Programm erstellen</Fab>
          </div>}
        </div>
        {this.state.program_data.length === 0 && (<Paper style={{ position: 'absolute', left: this.props.server_settings.state === 6 ? 'calc(40%)' : 'calc(20%)', top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Dieses Jahr sind noch keine Programme vorhanden"}</Typography></Paper>)}
        {/* Kinder Liste */}
        {this.props.server_settings.state !== 6 && <div style={{ position: "absolute", left: "calc(40%)", width: "calc(60% - 5px)", top: 95, height: "calc(100% - 140px)" }}>
          {this.state.selected_program === null && <Paper style={{ position: 'absolute', left: 'calc(50%)', top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Bitte wählen Sie eines Ihrer Programme aus, um die Teilnehmerliste zu sehen."}</Typography></Paper>}
          {this.state.selected_program !== null && <ParticipantList data={this.state.children_data} name={this.state.selected_program.event} leaderEmail={this.props.userData.email} server_settings={this.props.server_settings} />}
        </div>}
        {/* Programme vom letzten Jahr */}
        {this.props.server_settings.state === 6 && <Scrollbars style={{ position: "absolute", right: 0, width: "40%", top: 90, height: "calc(100% - 130px)" }}>
          {this.state.program_data.map(program => (
            <Fragment>
              {(program.event.toLowerCase().includes(this.props.searchString.toLowerCase()) || program.year_ai.includes(this.props.searchString) || program.city.toLowerCase().includes(this.props.searchString.toLowerCase())) && program.leader_id === this.props.userData.id && program.date_from.includes((new Date().getFullYear() - 1).toString()) && <ExpansionPanel expanded={this.state.expanded === program.id.toString()} onChange={this.handlePanelChange(program)} style={{ borderRadius: 7, margin: 5, marginRight: 10 }}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading} align="left" style={{ marginRight: 155 }}>{program.year_ai + ". " + program.event}</Typography>
                  <Typography className={classes.secondaryHeading} align="right">{moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'short' }) + ". " + program.date_from.substring(0, 6) + (program.time_from !== "" ? " " + program.time_from : "")}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div>
                    <Typography align="left">{"Termin: " + moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'long' }) + " " + program.date_from + (program.date_to !== program.date_from ? " - " + program.date_to : "") + (program.time_from !== "" ? " von " + program.time_from + " bis " + program.time_to : "")}</Typography>
                    <Typography align="left">{"Treffpunkt: " + program.location}</Typography>
                    <Typography align="left">{"Leiter/in: " + program.first_name + " " + program.last_name + ", " + program.department}</Typography>
                    <Typography align="left">Kontakt: <Link href={"mailto:" + program.email}>{program.email}</Link> / <Link href={"tel:" + program.tel}>{program.tel}</Link></Typography>
                    {program.cl_first_name !== "" && <Typography align="left">{"Co-Leiter/in: " + program.cl_first_name + " " + program.cl_last_name}</Typography>}
                    {program.cl_first_name !== "" && <Typography align="left">Kontakt: <Link href={"mailto:" + program.cl_email}>{program.cl_email}</Link> / <Link href={"tel:" + program.cl_tel}>{program.cl_tel}</Link></Typography>}
                    <Typography align="left">{"Kosten: " + (program.price === "0" ? "kostenlos" : parseFloat(program.price).toFixed(2).replace(".", ",") + " €")}</Typography>
                    {(program.age_min !== "0" || program.age_max !== "0") && <Typography align="left">{"Alter: " + (program.age_max === "0" ? "ab " + program.age_min + " Jahren" : program.age_min + " - " + program.age_max + " Jahre")}</Typography>}
                    {program.push_notes !== "" && <Typography align="left">{"Mitzubringen: " + program.push_notes}</Typography>}

                    <Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}>{program.description.split(" ^ ").join("\n").split("^").join("\n")}</Typography>

                    {this.props.server_settings.state === 6 && <Tooltip title={"Dieses Programm wieder anbieten"} placement="top"><span><Button variant="outlined" onClick={() => this.addThisYear(program)} style={{ marginTop: 10 }} disabled={this.state.loading || this.props.server_settings.state === 5} color="primary">
                      {"Dieses Jahr wiederholen"}
                      {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button></span></Tooltip>}

                    {program.additional_info && <Tooltip title={"Zusätzliche Infos einsehen"} placement="top"><span><Button variant="outlined" href={"https://formulare-schemmerhofen.de/files/fepro/info_" + program.year_ai + ".pdf"} target="blank" style={{ marginTop: 10, marginLeft: 10 }} disabled={this.state.loading} color="primary">
                      {"Zusätzliche Infos"}
                    </Button></span></Tooltip>}
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>}
            </Fragment>
          ))}
        </Scrollbars>}
        {/* AddProgramDialog */}
        <AddProgramDialog open={this.state.dialog_add_program_open} userData={this.props.userData} program={this.state.selected_program} editMode={this.state.addProgramEditMode} onClose={this.addedProgram} />
        {/* RemoveProgramDialog */}
        {this.state.selected_program !== null && <RemoveProgramDialog open={this.state.dialog_remove_program_open} onClose={this.removedProgram} programID={this.state.selected_program.id} />}

        {/* Success-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_success_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>{this.state.snackbar_message}</span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>
            ]}
            style={{ backgroundColor: green[600] }} />
        </Snackbar>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}><ErrorIcon className={classes.icon} />{this.state.snackbar_message}</span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Fragment>
    );
  }
}

AdministrationLeader.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  server_settings: PropTypes.object.isRequired,
  ikey: PropTypes.string,
  searchString: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(AdministrationLeader);
